import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { OperatorService } from '../services/operator.service';

@Component({
  selector: 'app-impossibility-supply',
  templateUrl: './impossibility-supply.component.html',
  styleUrls: ['./impossibility-supply.component.scss']
})
export class ImpossibilitySupplyComponent implements OnInit {

  public operatorProjection: any;
  public impossibilitySupplyForm: FormGroup;
  public cui: string = 'CUI';
  public supplierName: string = 'Denumire furnizor';
  public decisionImpossibilityOfSupply: string = 'Decizie imposibilitate furnizare';
  public startDate: string = 'Data inceput';
  public impossibilityReason: string = 'Motiv imposibilitate';
  public transferringCustomersToFUI: string = 'Trecere clienti la FUI';
  public decisionConfirmationPopup: string = 'Esti sigur ca vrei sa treci furnizorul in imposibilitate de furnizare?';
  public transferringCustomersToFUISubmitAttempt: boolean = false;
  public minDate: Date;

  constructor(
    private formBuilder: FormBuilder,
    private operatorService: OperatorService,
    private toastrService: ToastrService
  ) {
    this.minDate = new Date();
    this.minDate.setDate(this.minDate.getDate() + 2);
    this.operatorProjection = JSON.parse(localStorage.getItem('operatorProjection'));
  }

  ngOnInit(): void {
    this.initImpossibilitySupplyForm();
  }

  initImpossibilitySupplyForm(): void {
    this.impossibilitySupplyForm = this.formBuilder.group({
      cui: new FormControl({ value: this.operatorProjection.code, disabled: true }),
      supplierName: new FormControl({ value: this.operatorProjection.supplier, disabled: true }),
      startDate: ['', Validators.required],
      impossibilityReason: ['', Validators.required]
    });
  }

  onDisplayRequiredField(field: string): any {
    return {
      'input-required': !this.isFieldValid(field) && this.transferringCustomersToFUISubmitAttempt,
    };
  }

  isFieldValid(field: string): boolean {
    return this.impossibilitySupplyForm.get(field).valid;
  }

  onTransferringCustomersToFUI(): void {
    Swal.fire({
      html: this.decisionConfirmationPopup,
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Anuleaza',
      customClass: {
        popup: 'popup-z-elevate-24-blue'
      }
    }).then(result => {
      if (result.value) {
        this.transferringCustomersToFUISubmitAttempt = true;
        if (this.impossibilitySupplyForm.invalid) {
          return;
        }
        const requestObject: any = {
          series: this.operatorProjection.series,
          placeType: this.operatorProjection.placeType,
          statusChangeReason: this.impossibilitySupplyForm.get('impossibilityReason').value,
          statusChangeDate: this.impossibilitySupplyForm.get('startDate').value
        };
        this.operatorService.cancelSupplier(requestObject).subscribe(supplier => {
          this.toastrService.success('Furnizorul a fost trecut in imposibilitate de furnizare');
          history.back();
        }
        );
      }
    });
  }

}
